export default "__VITE_ASSET__1ff9b825__"